// A click breadcrumb carries the clicked element's text, which in the builder can be a
// tenant's own content or a customer's name. The selector is enough to follow the trail.
export function stripClickText (breadcrumbs: any[] | undefined): void {
  (breadcrumbs || []).forEach((crumb) => {
    if (crumb.type === 'user' && crumb.metadata) {
      delete crumb.metadata.targetText
    }
  })
}
